/**
 * Location Accuracy Utilities
 *
 * Constants and helper functions for location accuracy mode.
 */

export type LocationAccuracyMode = 'precise' | 'balanced' | 'quick'

const STORAGE_KEY = 'crowdtalkie_location_accuracy'

export const ACCURACY_MODES: Record<
  LocationAccuracyMode,
  {
    label: string
    shortLabel: string
    description: string
    icon: string
    accuracy: string
  }
> = {
  precise: {
    label: 'Precise (GPS)',
    shortLabel: 'Precise',
    description: 'Best for creating rooms & POIs',
    icon: '🎯',
    accuracy: '~5-50m',
  },
  balanced: {
    label: 'Balanced',
    shortLabel: 'Balanced',
    description: 'Good accuracy, faster response',
    icon: '📍',
    accuracy: '~100-500m',
  },
  quick: {
    label: 'Quick (IP)',
    shortLabel: 'Quick',
    description: 'Fastest, approximate location',
    icon: '🌐',
    accuracy: '~5km',
  },
}

export function getStoredAccuracyMode(): LocationAccuracyMode {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored && (stored === 'precise' || stored === 'balanced' || stored === 'quick')) {
      return stored
    }
  } catch {
    // localStorage not available
  }
  return 'precise' // Default to precise
}

export function setStoredAccuracyMode(mode: LocationAccuracyMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, mode)
  } catch {
    // localStorage not available
  }
}
